import React from 'react';

import { SaviChatInput } from '../../../components';
import { useIspmContext } from '../../../context';

import './SaviChatFooter.css';

export default function SaviChatFooter() {
  const { ispmState, updateIspmState } = useIspmContext();

  return (
    <footer className='Ispm-SaviChatFooter'>
      <SaviChatInput />
      {/**
       * TODO: delete below DEV only code.
       */}
      <div>
        <label htmlFor='mockApiToggle'>
          <input
            type='checkbox'
            checked={ispmState.useMockServerApis}
            onChange={() => {
              updateIspmState(
                'useMockServerApis',
                !ispmState.useMockServerApis
              );
            }}
          />
          Use Mock API
        </label>
      </div>
    </footer>
  );
}
